.scenario {
	cursor: default;
	display: flex;
	align-items: center;
}

.scenarioTitle {
	flex: 1 0 auto;
	max-width: 70px;
	overflow: hidden;
	text-align: start;
	text-overflow: ellipsis;
	white-space: nowrap;

	&.isReportMode {
		max-width: 110px;
	}
}

@media (min-width: 1280px) {
	.scenarioTitle {
		max-width: 80px;

		&.isReportMode {
			max-width: 155px;
		}
	}
}

@media (min-width: 1440px) {
	.scenarioTitle {
		max-width: 90px;

		&.isReportMode {
			max-width: 175px;
		}
	}
}

@media (min-width: 1536px) {
	.scenarioTitle {
		max-width: 95px;

		&.isReportMode {
			max-width: 185px;
		}
	}
}

@media (min-width: 1680px) {
	.scenarioTitle {
		max-width: 100px;

		&.isReportMode {
			max-width: 200px;
		}
	}
}

@media (min-width: 1920px) {
	.scenarioTitle {
		max-width: 105px;

		&.isReportMode {
			max-width: 225px;
		}
	}
}

.scenarioSwatch {
	margin-right: calc(var(--jpo-common-base-spacing));
	width: 16px;
	height: 16px;
	border-radius: 3px;
}

.scenarioSwitcherMenuHeader {
	color: var(--ds-text-subtlest, var(--adg3-color-N200));
	font-weight: 500;
	padding: var(--jpo-common-base-spacing) calc(2 * var(--jpo-common-base-spacing));
}

.scenariosList {
	border-bottom: 1px solid var(--ds-border, var(--adg3-color-N40A));
	overflow-x: hidden;
	overflow-y: auto;
	/* This removes scrollbars that appear from overlapped elements in IE11 */
	-ms-overflow-style: auto;
	max-height: 180px; /* Enough to show 4.5 scenarios */
	min-width: 300px;
}

@media (min-height: 650px) {
	.scenariosList {
		max-height: 260px; /* Enough to show 6.5 scenarios */
	}
}

@media (min-height: 750px) {
	.scenariosList {
		max-height: 300px; /* Enough to show 7.5 scenarios */
	}
}

@media (min-height: 820px) {
	.scenariosList {
		max-height: 340px; /* Enough to show 8.5 scenarios */
	}
}

.activeScenarioItem {
	background: var(--ds-background-neutral, var(--adg3-color-N20));
}

.scenarioItemColor {
	border-radius: 3px;
	height: 16px;
	margin: calc(var(--jpo-common-base-spacing) / 2);
	width: 16px;
}

.scenarioButton {
	align-items: center;
	display: flex;
}

.scenarioReadOnlyWrapper {
	align-self: center;
	display: flex;
	margin-left: var(--jpo-common-base-spacing);
	padding: 6px 0;
}

.scenarioWrapper {
	margin-left: calc(var(--jpo-common-base-spacing));
}
